
import React, { useContext, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import PedidoStatus from './PedidoStatus';
import styles from './PedidoStatusLayout.module.css';
import { MyContext } from '../context/UserProvider';
import Navbar from '../../layout/Navbar';
import Footer from '../../layout/Footer';
import CheckoutPayment from '../../mercadoPago/CheckoutPayment';

export default function PedidoStatusLayout() {
    const { setScrollY, showCheckoutPayment, usuario, dataUser } = useContext(MyContext);
    const location = useLocation();

    const pedidoId = location.state?.pedido_id || null;

    useEffect(() => {
        setScrollY(1);
    }, [setScrollY]);

    return (
        <div
            className={styles['pedido-status-layout-container']}
            style={{
                display: 'flex',
                flexDirection: 'column',
                minHeight: '100vh',
                minHeight: '100dvh',
                width: '100%',
                boxSizing: 'border-box',
            }}
        >
            <Navbar />

            <div
                className={styles['pedido-status-layout']}
                style={{
                    flex: '1 0 auto',
                    width: '100%',
                    minWidth: 0,
                    boxSizing: 'border-box',
                }}
            >
                {pedidoId && <PedidoStatus pedidoId={pedidoId} />}
            </div>

            <Footer />
        </div>
    );
}
